import { ReceivingConfirmRequestController } from './confirmRequest.controller';
import template from './confirmRequest.html';

export const receivingConfirmRequestComponent = {
  name: 'receivingConfirmRequestComponent',
  restrict: 'E',
  template,
  controller: ReceivingConfirmRequestController,
  controllerAs: 'vm',
  bindings: {
    ticket: '<',
    stateIndex: '<',
    skipState: '<'
  }
};
